// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fullscreen-fullscreen-271e{position:fixed;inset:0;background-color:#484848;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/page/Fullscreen/Fullscreen.module.scss"],"names":[],"mappings":"AAAA,4BACE,cAAA,CACA,OAAA,CACA,wBAAA,CACA,eAAA","sourcesContent":[".fullscreen {\n  position: fixed;\n  inset: 0;\n  background-color: #484848;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullscreen": `Fullscreen-fullscreen-271e`
};
module.exports = ___CSS_LOADER_EXPORT___;
